import {ResponseStatus} from "../../actions/types";
import {UserNotificationsSliceData} from "../slices/user-notifications.slice";
import {User} from "../../pages/shared/models/user/user";
import {PayloadAction} from "@reduxjs/toolkit";
import {PagingDataModel} from "../../pages/shared/models/paging-data.model";

export function handleGetNotifications(state: UserNotificationsSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.SUCCESS:
            if (payload && payload.notifications) {
                state.notificationsData = {...payload.notifications};
            } else if (payload && payload.notification) {
                state.notificationData = payload.notification;
            }
            state.isLoading = false;
            break;
    }
}

export function handleGetNotificationsCount(state: UserNotificationsSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.SUCCESS:
            if (payload && (payload.count || payload.count === 0)) {
                state.notificationsCount = payload.count;
            }
            state.isLoading = false;
            break;
    }
}

export function handleGetNotificationTemplates(state: UserNotificationsSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.SUCCESS:
            if (payload && payload.notificationTemplates) {
                const templates = {...payload.notificationTemplates};
                const statusTemplates = templates.templates.filter((template: NotificationTemplate) => template.templateType === 1);
                const transactionTemplates = templates.templates.filter((template: NotificationTemplate) => template.templateType === 2);

                state.statusNotificationTemplates = {
                    templates: statusTemplates,
                    totalItems: templates.totalItems - transactionTemplates.length,
                    currentPage: templates.currentPage,
                    pageSize: templates.pageSize
                };
                state.transactionNotificationTemplates = {
                    templates: transactionTemplates,
                    totalItems: transactionTemplates.length,
                    currentPage: templates.currentPage,
                    pageSize: templates.pageSize
                };
            }
            state.isLoading = false;

            break;
    }
}

export function onPaginationChange (state: UserNotificationsSliceData, action: PayloadAction<PagingDataModel>): void {
        state.notificationsData.pageSize = action.payload.pageSize;
        state.notificationsData.currentPage = action.payload.currentPage;
}

export interface NotificationModel {
    userNotificationId: number,
    seen: boolean,
    subject: any, // TODO: add types
    body: any, // TODO: add types
    sendDate: number,
    relatedUser: User
}

export interface NotificationTemplate {
    notificationTemplateId: number;
    section: string;
    subject: string;
    body: string,
    templateType: number
}